package com.solevo.dist.network.firebase.api.invoice.models

import com.solevo.dist.application.models.DocMetadata
import com.solevo.dist.application.models.Invoice
import com.solevo.dist.network.implementation.firebase.utils.time.toKotlinInstant
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class FirebaseInvoice(
    var invoiceId: String = "",
    var invoiceNumber: String = "",
    val legalEntityId: String? = null,
    var customerId: String = "",
    var orderId: String = "",
    var dueDate: Timestamp = Timestamp.now(),
    var created: Timestamp = Timestamp.now(),
    var totalPrice: Double = 0.0,
    var paid: Double = 0.0,
    var remaining: Double = 0.0,
    var invoiceLines: List<FirebaseInvoiceLines> = listOf(),
    var docMetadata: DocMetadata? = DocMetadata(),
)

@Serializable
data class FirebaseInvoiceLines(
    var id: String? = "",
    val invoiceId: String? = null,
    var productId: String? = "",
    var description: String? = "",
    var quantity: Double = 0.0,
    var pricePerUnit: Double = 0.0,
    var totalPrice: Double = 0.0,
    var unit: String? = "",
    var invoiceNumber: String? = "",
    val lineNumber: Double = 0.0
)

fun FirebaseInvoice.toInvoice() = Invoice(
    invoiceId = invoiceId,
    invoiceNumber = invoiceNumber,
    legalEntityId = legalEntityId,
    customerId = customerId,
    orderId = orderId,
    dueDate = dueDate.toKotlinInstant(),
    created = created.toKotlinInstant(),
    totalPrice = totalPrice,
    paid = paid,
    remaining = remaining,
    invoiceLines = invoiceLines.map { it.toInvoiceLines() },
    docMetadata = docMetadata
)

fun FirebaseInvoiceLines.toInvoiceLines() = com.solevo.dist.application.models.InvoiceLines(
    id = id,
    invoiceId = invoiceId,
    productId = productId,
    description = description,
    quantity = quantity,
    pricePerUnit = pricePerUnit,
    totalPrice = totalPrice,
    unit = unit,
    invoiceNumber = invoiceNumber,
    lineNumber = lineNumber
)


